module.exports = __webpack_public_path__ + "img/IMG_1444_L_Black.025a4a0f.jpg";